import { combineReducers } from "redux";
import { reducer as appBreadcrumbsReducer } from "./breadcrumbs";
import { reducer as navigateToReducer } from "./navigateTo";

export const reducer = combineReducers({
  breadcrumbs: appBreadcrumbsReducer,
  navigateTo: navigateToReducer,
});
